import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const verifyInvoice = (invoice) => apiActionCreator({
  'endpoint': `/checkProcesses/invoices/${invoice}/verification`,
  'authenticated': true,
  'types': [
    ActionTypes.VERIFYING_INVOICE,
    ActionTypes.VERIFIED_INVOICE,
    [
      ActionTypes.VERIFIED_INVOICE_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const changeVerifyInvoiceListPage = (value) => ({
  'type': ActionTypes.CHANGE_VERIFY_INVOICE_LIST_PAGE,
  'payload': value,
});

export const changeVerifyInvoiceListPageSize = (value) => ({
  'type': ActionTypes.CHANGE_VERIFY_INVOICE_LIST_PAGE_SIZE,
  'payload': value,
});
